export default "__VITE_ASSET__735eaed9__"